import React,{Component}from 'react';
import { Icon ,Tooltip,Whisper} from 'rsuite';
class CloseBar extends Component {
    tooltip(open){
        return(
        <Tooltip>{open?"隐藏导航栏":"显示导航栏"}</Tooltip>
        )
    }
    render(){
        const {open}=this.props;
        return(
            <Whisper placement="right" 
                trigger="hover"
                speaker={this.tooltip(open)}>
            <div 
                id="closebar" 
                className={open?'closebar-move-left':'closebar-move-right'}
                style={open?{left:'160px'}:{}}
                onClick={this.props.onClick}
            >
                <Icon icon={'close'} />
            </div>
            </Whisper>
        );
    }
}
export default CloseBar;